export default "/images/converse_bank.png?6aaa26ae612276ba200d991adbdf64fc";